import React, { useState, useEffect } from "react";
import { Layout } from "antd";
import PropTypes from "prop-types";
import GeneralSettings from "./components/GeneralSettings";
import SystemTables from "./components/SystemTables";
import HouseVisits from "./components/HouseVisits";
import Wage from "./components/Wage";
import Clients from "./components/Clients";
import InterfacesSettings from "./components/InterfacesSettings";
import Contracts from "../contracts";
import Forms from "./components/forms/Forms";
import { Tabs } from "antd";
import { FormattedMessage } from "react-intl";
import AnimationWrapper from "../../components/animations/AnimationWrapper";
import { isAllowedFeature } from "../organization/organizationSlice";
import { useDispatch } from "react-redux";
import { loadSettings } from "../organization/organizationSlice";
import { useSelector } from "react-redux";
import { usePermission } from "../../hooks/accessControl";
import { useParams } from "react-router-dom";
import { useSuperAdmin } from "../../hooks/accessControl";

const { TabPane } = Tabs;

const Settings = (props) => {
  let { branchId } = useParams();
  const isSuperAdmin = useSuperAdmin();
  const [activekey, setActiveKey] = useState();
  const [tabs, setTabs] = useState([]);
  const dispatch = useDispatch();
  const features = useSelector((state) => state.organization.settings.features);
  const hasViewerPermission = usePermission(
    branchId,
    "organization.settings",
    "viewer"
  );

  useEffect(() => {
    if (hasViewerPermission) {
      dispatch(loadSettings());
    }
  }, [dispatch, hasViewerPermission, activekey]);

  useEffect(() => {
    const components = [
      {
        key: "general",
        titleId: "app.settings.general",
        comp: <GeneralSettings activekey={activekey} />,
      },
      {
        key: "system_tables",
        titleId: "app.settings.system_tables",
        comp: <SystemTables activekey={activekey} />,
      },
      {
        key: "house_visits",
        titleId: "app.settings.house_visits",
        comp: <HouseVisits activekey={activekey} />,
      },
      {
        key: "wage",
        titleId: "app.settings.wage",
        comp: <Wage activekey={activekey} />,
      },
      {
        key: "clients",
        titleId: "app.settings.accounting",
        comp: <Clients activekey={activekey} />,
      },
      {
        key: "sync",
        titleId: "app.settings.interfaces",
        comp: <InterfacesSettings activekey={activekey} />,
      },
    ];

    const additionalComponents = [];
    if (isAllowedFeature("contracts")) {
      additionalComponents.push({
        key: "contracts",
        titleId: "app.settings.contracts",
        comp: <Contracts activekey={activekey} />,
      });
    }

    if (isSuperAdmin) {
      additionalComponents.push({
        key: "forms",
        titleId: "app.settings.forms",
        comp: <Forms activekey={activekey} />,
      });
    }
    setTabs([...components, ...additionalComponents]);
  }, [activekey, features]);

  const onChange = (key) => {
    setActiveKey(key);
  };

  return (
    <Layout>
      <Tabs
        defaultActiveKey="general"
        style={{}}
        onChange={onChange}
        items={tabs.map((option) => ({
          label: <FormattedMessage id={option.titleId} />,
          key: option.key,
          children: (
            <AnimationWrapper duration={0.6}>{option.comp}</AnimationWrapper>
          ),
        }))}
      />
    </Layout>
  );
};

Settings.propTypes = {
  mode: PropTypes.string,
};

export default Settings;
